export default __webpack_public_path__ + "static/media/2010-12-0025.a64bc2b5.jpg";